import Image from "next/image";
import React from "react";
import styles from "../upsc-mains-test-series/upsc-mains-test-series-2023.module.css";
import Link from "next/link";
import rightarrow from "../../assets/images/upsc/rightarrow.svg";

const UPSC_Main_Test_Series_2023 = () => {

    const maintest =[
        {Image: rightarrow,cont:"Geography",date:"22-06-2022",url:"/pdf/upsc-mains/optional/tamilnadu/Geography.pdf"},
        {Image: rightarrow,cont:"Psychology",date:"28-06-2022",url:"/pdf/upsc-mains/optional/tamilnadu/Psychology.pdf"},
        {Image: rightarrow,cont:"Public administration",date:"21-06-2022",url:"/pdf/upsc-mains/optional/tamilnadu/Pubc-Ad.pdf"},
        {Image: rightarrow,cont:"Law",date:"30-06-2022",url:"/pdf/upsc-mains/optional/tamilnadu/Law-Class.pdf"},
        {Image: rightarrow,cont:"History - Chennai & Delhi",date:"16-06-2022",url:"/pdf/upsc-mains/optional/tamilnadu/History.pdf"},
        {Image: rightarrow,cont:"Agriculture",date:"13-06-2022",url:"/pdf/upsc-mains/optional/tamilnadu/Agriculture.pdf"},
        {Image: rightarrow,cont:"Mathematics (Repeaters)",date:"30-06-2022",url:"/pdf/upsc-mains/optional/tamilnadu/Mathematics-Repeaters.pdf"},
        {Image: rightarrow,cont:"Mathematics (First Timers)",date:"25-06-2022",url:"/pdf/upsc-mains/optional/tamilnadu/Mathematics-timers.pdf"},
        {Image: rightarrow,cont:"Political Science Batch-1",date:"29-06-2022",url:"/pdf/upsc-mains/optional/tamilnadu/PSIR-BATCH-1.pdf"},
        {Image: rightarrow,cont:"Political Science Batch-2",date:"18-08-2022",url:"/pdf/upsc-mains/optional/tamilnadu/PSIR-BATCH-2.pdf"},
        {Image: rightarrow,cont:"Sociology Batch-1",date:"14-06-2022",url:"/pdf/upsc-mains/optional/tamilnadu/Sociology-Batch-1.pdf"},
        {Image: rightarrow,cont:"Sociology Batch-2",date:"14-06-2022",url:"/pdf/upsc-mains/optional/tamilnadu/Socilogy-Batch-2.pdf"},
        {Image: rightarrow,cont:"Anthropology",date:"22-06-2022",url:"/pdf/upsc-mains/optional/tamilnadu/Anthropology.pdf"}
      ]
      const maintest1 =[
        {Image: rightarrow,cont:"Geography",date:"22-06-2022",url:"/pdf/upsc-mains/optional/delhi/Geography.pdf"},
        {Image: rightarrow,cont:"History",date:"16-06-2022",url:"/pdf/upsc-mains/optional/delhi/History.pdf"},
        {Image: rightarrow,cont:"Political Science Batch-1",date:"29-06-2022",url:"/pdf/upsc-mains/optional/delhi/PSIR-BATCH-1.pdf"},
        {Image: rightarrow,cont:"Political Science Batch-2",date:"18-08-2022",url:"/pdf/upsc-mains/optional/delhi/PSIR-batch2.pdf"},
        {Image: rightarrow,cont:"Sociology Batch-1",date:"14-6-2022",url:"/pdf/upsc-mains/optional/delhi/Sociology-Batch-1.pdf"},
        {Image: rightarrow,cont:"Sociology Batch-2",date:"14-06-2022",url:"/pdf/upsc-mains/optional/delhi/Sociology-Batch-2.pdf"},
        {Image: rightarrow,cont:"Anthropology",date:"22-06-2022",url:"/pdf/upsc-mains/optional/delhi/Anthropology.pdf"}
      ]

      const maintest2 =[
        {Image: rightarrow,cont:"Psychology",date:"28-06-2022",url:"/pdf/upsc-mains/optional/online/Psychology.pdf"},
        {Image: rightarrow,cont:"Public administration",date:"21-06-2022",url:"/pdf/upsc-mains/optional/online/Pubc-Ad.pdf"},
        {Image: rightarrow,cont:"Law",date:"30-06-2022",url:"/pdf/upsc-mains/optional/online/Law-Class.pdf"},
        {Image: rightarrow,cont:"Agriculture",date:"13-06-2022",url:"/pdf/upsc-mains/optional/online/Agriculture.pdf"},
        {Image: rightarrow,cont:"Mathematics (Repeaters)",date:"30-6-2022",url:"/pdf/upsc-mains/optional/online/Mathematics-Repeaters.pdf"},
        {Image: rightarrow,cont:"Mathematics (First Timers)",date:"25-06-2022",url:"/pdf/upsc-mains/optional/online/Mathematics-first-timers-1.pdf"}
        
      ]

      
      const Bengaluru =[
        {Image: rightarrow,cont:"Geography",date:"22-06-2022",url:"/pdf/upsc-mains/optional/bangalore/Geography.pdf"},
        {Image: rightarrow,cont:"Psychology",date:"28-06-2022",url:"/pdf/upsc-mains/optional/bangalore/Psychology.pdf"},
        {Image: rightarrow,cont:"Public administration",date:"21-06-2022",url:"/pdf/upsc-mains/optional/bangalore/Pubc-Ad.pdf"},
        {Image: rightarrow,cont:"Law",date:"30-06-2022",url:"/pdf/upsc-mains/optional/bangalore/Law-Class.pdf"},
        {Image: rightarrow,cont:"History",date:"16-06-2022",url:"/pdf/upsc-mains/optional/bangalore/History.pdf"},
        {Image: rightarrow,cont:"Agriculture",date:"13-06-2022",url:"/pdf/upsc-mains/optional/bangalore/Agriculture.pdf"},
        {Image: rightarrow,cont:"Mathematics (Repeaters)",date:"30-06-2022",url:"/pdf/upsc-mains/optional/bangalore/Mathematics-Repeater.pdf"},
        {Image: rightarrow,cont:"Mathematics (First Timers)",date:"25-06-2022",url:"/pdf/upsc-mains/optional/bangalore/Mathematics-first-timers.pdf"},
        {Image: rightarrow,cont:"Political Science Batch-1",date:"29-06-2022",url:"/pdf/upsc-mains/optional/bangalore/PSIR-BATCH-1.pdf"},
        {Image: rightarrow,cont:"Political Science Batch-2",date:"18-08-2022",url:"/pdf/upsc-mains/optional/bangalore/PSIR-BATCH-2.pdf"},
        {Image: rightarrow,cont:"Sociology Batch-1",date:"14-06-2022",url:"/pdf/upsc-mains/optional/bangalore/Sociology-Batch-1.pdf"},
        {Image: rightarrow,cont:"Sociology Batch-2",date:"14-06-2022",url:"/pdf/upsc-mains/optional/bangalore/Sociology-Batch-2.pdf"},
        {Image: rightarrow,cont:"Anthropology",date:"22-06-2022",url:"/pdf/upsc-mains/optional/bangalore/Anthropology.pdf"}
        
      ]

      const Trivandrum =[
        {Image: rightarrow,cont:"Geography",date:"22-06-2022",url:"/pdf/upsc-mains/optional/trivandrum/Geography.pdf"},
        {Image: rightarrow,cont:"Psychology",date:"28-06-2022",url:"/pdf/upsc-mains/optional/trivandrum/Psychology.pdf"},
        {Image: rightarrow,cont:"Public administration",date:"21-06-2022",url:"/pdf/upsc-mains/optional/trivandrum/Pubc-Ad.pdf"},
        {Image: rightarrow,cont:"Law",date:"30-06-2022",url:"/pdf/upsc-mains/optional/trivandrum/Law-Class.pdf"},
        {Image: rightarrow,cont:"History",date:"16-06-2022",url:"/pdf/upsc-mains/optional/trivandrum/History.pdf"},
        {Image: rightarrow,cont:"Agriculture",date:"13-06-2022",url:"/pdf/upsc-mains/optional/trivandrum/Agriculture.pdf"},
        {Image: rightarrow,cont:"Mathematics (Repeaters)",date:"30-06-2022",url:"/pdf/upsc-mains/optional/trivandrum/Mathematics-Repeaters.pdf"},
        {Image: rightarrow,cont:"Mathematics (First Timers)",date:"25-06-2022",url:"/pdf/upsc-mains/optional/trivandrum/Mathematics-first-timers.pdf"},
        {Image: rightarrow,cont:"Political Science Batch-1",date:"29-06-2022",url:"/pdf/upsc-mains/optional/trivandrum/PSIR-BATCH-1.pdf"},
        {Image: rightarrow,cont:"Political Science Batch-2",date:"18-08-2022",url:"/pdf/upsc-mains/optional/trivandrum/PSIR-BATCH-2.pdf"},
        {Image: rightarrow,cont:"Sociology Batch-1",date:"14-06-2022",url:"/pdf/upsc-mains/optional/trivandrum/Sociology-Batch-1.pdf"},
        {Image: rightarrow,cont:"Sociology Batch-2",date:"14-06-2022",url:"/pdf/upsc-mains/optional/trivandrum/Sociology-Batch-2.pdf"},
        {Image: rightarrow,cont:"Anthropology",date:"22-06-2022",url:"/pdf/upsc-mains/optional/trivandrum/Anthropology.pdf"}
        
      ]
      
    return (
        <>
      <div className="container pt-3">
                                <div className="row">
                                    <div className="col">
                                        <p className={`${styles.sectionsubtitle}`}>Medical Science optional Test Series</p>
                                    </div>
                                </div>
                            </div>

                            <div className="container">

                                <div className="row">
                                    <div className="col">
                                    <div className="row">

                                    <div className="col-md-6 col-lg-4 col-12">
                                    <div className={`${styles.classesborder} p-3 mb-3`}> 

                                        <div className="row">
                                            <div className="col-10 align-self-center">
                                            <p className={`${styles.acheivername} mb-0`}>Medical Science</p>
                                            <p className={`${styles.acheiverrank} mb-0`}>14-08-2022</p>
                                            </div>
                                            <div className="col-2 pe-0 align-self-center">
                                        <a href="/pdf/upsc-mains/optional/medical-science.pdf" target="_blank"><Image src={rightarrow} alt="arrow icon" title="Link" className="img-fluid" type="button"/></a>  
                                            </div>
                                        </div>

                                    </div>
                                    </div>
                                    
                                    </div>
                                    </div>
                                </div>

                            </div>
                            
                           {/* Tamilnadu */}
                            <div className="container">
                                <div className="row">
                                    <div className="col">
                                        <p className={`${styles.sectionsubtitle}`}>Tamilnadu</p>
                                    </div>
                                </div>
                            </div>

                            <div className="container">

                                <div className="row">
                                    <div className="col">
                                    <div className="row">
                                        {maintest.map((item,index)=>(
                                             <div className="col-md-6 col-lg-4 col-12" key={index}>
                                             <div className={`${styles.classesborder} p-3 mb-3`}> 
     
                                                 <div className="row">
                                                     <div className="col-10 align-self-center">
                                                     <p className={`${styles.acheivername} mb-0`}>{item.cont}</p>
                                                     <p className={`${styles.acheiverrank} mb-0`}>{item.date}</p>
                                                     </div>
                                                     <div className="col-2 pe-0 align-self-center">
                                                     <a href={item.url} rel="noreferrer" target="_blank"><Image src={item.Image} alt="arrow icon" title="Link" className="img-fluid" type="button"/></a>  
                                                     </div>
                                                 </div>
     
                                             </div>
                                         </div>
                                        ))}
                                    
                                </div>
                            </div>
                     </div>

            </div>

                           {/*  Delhi */}
                            <div className="container">
                                <div className="row">
                                    <div className="col">
                                        <p className={`${styles.sectionsubtitle}`}>Delhi</p>
                                    </div>
                                </div>
                            </div>

                            <div className="container">

                                <div className="row">
                                    <div className="col">
                                    <div className="row">

                                        {maintest1.map((item,index)=>(
                                            <div className="col-md-6 col-lg-4 col-12" key={index}>
                                            <div className={`${styles.classesborder} p-3 mb-3`}> 

                                                <div className="row">
                                                    <div className="col-10 align-self-center">
                                                    <p className={`${styles.acheivername} mb-0`}>{item.cont}</p>
                                                    <p className={`${styles.acheiverrank} mb-0`}>{item.date}</p>
                                                    </div>
                                                    <div className="col-2 pe-0 align-self-center">
                                                    <a href={item.url} rel="noreferrer" target="_blank"><Image src={item.Image} alt="arrow icon" title="Link" className="img-fluid" type="button"/></a>  
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        ))}
                                
                                    </div>
                                    </div>
                                </div>
                            </div>

                               {/* Online */}
                            <div className="container">
                                <div className="row">
                                    <div className="col">
                                        <p className={`${styles.sectionsubtitle}`}>Online</p>
                                    </div>
                                </div>
                            </div>

                            <div className="container">

                                <div className="row">
                                    <div className="col">
                                    <div className="row">


                                    {maintest2.map((item,index)=>(
                                            <div className="col-md-6 col-lg-4 col-12" key={index}>
                                            <div className={`${styles.classesborder} p-3 mb-3`}> 

                                                <div className="row">
                                                    <div className="col-10 align-self-center">
                                                    <p className={`${styles.acheivername} mb-0`}>{item.cont}</p>
                                                    <p className={`${styles.acheiverrank} mb-0`}>{item.date}</p>
                                                    </div>
                                                    <div className="col-2 pe-0 align-self-center">
                                                    <a href={item.url} rel="noreferrer" target="_blank"><Image src={item.Image} alt="arrow icon" title="Link" className="img-fluid" type="button"/></a>  
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    ))}
                                
                                    </div>
                                    </div>
                                </div>

                            </div>

                           {/* Bengaluru */}
                            <div className="container">
                                <div className="row">
                                    <div className="col">
                                        <p className={`${styles.sectionsubtitle}`}>Bengaluru</p>
                                    </div>
                                </div>
                            </div>

                            <div className="container">

                                <div className="row">
                                    <div className="col">
                                    <div className="row">

                                    {Bengaluru.map((item,index)=>(
                                            <div className="col-md-6 col-lg-4 col-12" key={index}>
                                            <div className={`${styles.classesborder} p-3 mb-3`}> 

                                                <div className="row">
                                                    <div className="col-10 align-self-center">
                                                    <p className={`${styles.acheivername} mb-0`}>{item.cont}</p>
                                                    <p className={`${styles.acheiverrank} mb-0`}>{item.date}</p>
                                                    </div>
                                                    <div className="col-2 pe-0 align-self-center">
                                                    <a href={item.url} rel="noreferrer" target="_blank"><Image src={item.Image} alt="arrow icon" title="Link" className="img-fluid" type="button"/></a>  
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    ))}
                                    
                                    </div>
                                    </div>
                                </div>

                            </div>

                            {/* Trivandrum */}
                            <div className="container">
                                <div className="row">
                                    <div className="col">
                                        <p className={`${styles.sectionsubtitle}`}>Trivandrum</p>
                                    </div>
                                </div>
                            </div>

                            <div className="container">

                                <div className="row">
                                    <div className="col">
                                    <div className="row">

                                    {Trivandrum.map((item,index)=>(
                                            <div className="col-md-6 col-lg-4 col-12" key={index}>
                                            <div className={`${styles.classesborder} p-3 mb-3`}> 

                                                <div className="row">
                                                    <div className="col-10 align-self-center">
                                                    <p className={`${styles.acheivername} mb-0`}>{item.cont}</p>
                                                    <p className={`${styles.acheiverrank} mb-0`}>{item.date}</p>
                                                    </div>
                                                    <div className="col-2 pe-0 align-self-center">
                                                    <a href={item.url} rel="noreferrer" target="_blank"><Image src={item.Image} alt="arrow icon" title="Link" className="img-fluid" type="button"/></a>  
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    ))}
                                    
                                    </div>
                                    </div>
                                </div>

                            </div>      
               
</>
    )
}
export default UPSC_Main_Test_Series_2023;